<template>
    <v-main  >
        <v-container
            class="fill-height"
            fluid
            dark
            :style="{'background-image': 'url(' + require('../../assets/bak3.jpg') + ')'}"
            style="background-size: cover"
        >
            <v-row
                align="center"
                justify="center"
            >
                <v-col
                    cols="12"
                    sm="8"
                    md="5"
                >
                    <v-col cols="12" class="text-center">
                        <img alt="Login" src="../../assets/login_img.png" style="width: 150px;">
                    </v-col>
                    <v-card class="elevation-12">
                        <v-card-text>
                            <v-col cols="12" class="text-center">
                                Se enviará un mail a su correo para que pueda reestablecer su contraseña
                            </v-col>
                            <v-form ref="form_mail">
                                <v-text-field
                                    v-model="user"
                                    label="Ingrese su usuario"
                                    prepend-icon="mdi-account-circle"
                                    type="text"
                                    :rules=rule
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                            <v-spacer></v-spacer>
                             <v-col cols="12">
                                <v-btn 
                                    color="primary" 
                                    block
                                    class="px-5"
                                    :loading="loadingBtn"
                                    @click="sendMail"
                                >
                                    Enviar correo
                                </v-btn>
                             </v-col>
                    </v-card>
                </v-col>
            </v-row>
          </v-container>
    </v-main>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import axios from 'axios'
export default {
    name:'RecoverPasswordComponent',
    data : () => ({
        user:'',
        rule:[
            v => !!v || 'El correo es requerido'
        ]
    }),
    computed:{
        ...mapState(['loadingBtn'])
    },
    methods:{

        ...mapMutations(['setLoadingBtn','setUrl']),

        ...mapActions(['loginAction','requestApi','alertNotification']),

        sendMail(){

            if(!this.$refs.form_mail.validate())
                return
                
            this.setLoadingBtn()
            this.setUrl('user-laboratorio')
            this.requestApi({
                method:'PUT',
                data:{
                    data:{
                        user: this.user,
                        system: 'laboratorio',
                        dataBase: 'obinnoclinica'
                    }
                }
            })
            .then(res=>{
               this.alertNotification({
                    param:{
                        html : res.data.detail
                    }
                })
                this.setLoadingBtn()
              
            }).catch(()=>{
                this.setLoadingBtn()
            })
        }

    }
}
</script>
